module.exports = __webpack_public_path__ + "img/japan-pneumonia-male.f2fd12ba.png";